import { render } from "./patients-completed.vue?vue&type=template&id=b6636684"
import script from "./patients-completed.vue?vue&type=script&lang=js"
export * from "./patients-completed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__